import React, { useState } from 'react';

const ImplementationPhases = () => {
  const [activePhase, setActivePhase] = useState(0);

  const implementationPhases = [
    {
      phase: "Tahap Perencanaan",
      subtitle: "Menyusun tujuan, struktur, & regulasi program sebelum diimplementasi",
      icon: "fas fa-lightbulb",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-500",
      timeline: "Agustus - September 2025",
      activities: [
        {
          no: 1,
          title: "Membentuk Tim Manajemen Digitalisasi",
          description: "Ketua, koordinator pelatihan, infrastruktur, regulasi, teknis. Menyusun timeline & pembagian tugas.",
          deliverables: ["Struktur organisasi tim", "Job description masing-masing posisi", "Timeline detail program"],
          duration: "2-3 minggu"
        },
        {
          no: 2,
          title: "Menyusun Visi & Tujuan Digitalisasi",
          description: "Integrasi pembelajaran, pelaporan siswa, & manajemen kelas berbasis teknologi.",
          deliverables: ["Dokumen visi-misi digitalisasi", "Target pencapaian terukur", "KPI program"],
          duration: "1 minggu"
        },
        {
          no: 3,
          title: "Brainstorming Kebutuhan Digital Pembelajaran dengan tim guru",
          description: "Identifikasi aplikasi inti: platform belajar (Google Classroom, Jamboard, Notion), pelaporan, & MDM. Kebutuhan fitur dashboard presensi/pelanggaran.",
          deliverables: ["Daftar aplikasi yang dibutuhkan", "Spesifikasi fitur dashboard", "Requirement document"],
          duration: "2 minggu"
        },
        {
          no: 4,
          title: "Pemetaan Regulasi & SOP Penggunaan",
          description: "Penggunaan iPad (jam pakai, larangan, sanksi). Penyimpanan & pengisian daya. Pengawasan perangkat di kelas.",
          deliverables: ["Draft SOP penggunaan iPad", "Aturan sanksi dan reward", "Panduan penyimpanan"],
          duration: "2 minggu"
        },
        {
          no: 5,
          title: "Pemetaan Infrastruktur",
          description: "Akses internet di kelas. Kebutuhan charging station. Server MDM/cloud (jika perlu hosting internal).",
          deliverables: ["Assessment infrastruktur IT", "Rencana upgrade jaringan", "Spesifikasi server"],
          duration: "1 minggu"
        },
        {
          no: 6,
          title: "Rencana Pelatihan",
          description: "Materi, trainer, skenario implementasi. Durasi & metode (pelatihan & pendampingan).",
          deliverables: ["Kurikulum pelatihan", "Jadwal pelatihan bertahap", "Materi training"],
          duration: "2 minggu"
        }
      ]
    },
    {
      phase: "Tahap Persiapan",
      subtitle: "Memastikan kesiapan perangkat, sistem, & sarana pendukung",
      icon: "fas fa-tools",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-500",
      timeline: "Oktober - November 2025",
      activities: [
        {
          no: 1,
          title: "Pengadaan Perangkat iPad & MDM",
          description: "Menentukan jumlah unit. Mengurus vendor, garansi, & instalasi awal.",
          deliverables: ["iPad untuk semua pengguna", "Sistem MDM terinstall", "Dokumentasi garansi"],
          duration: "3-4 minggu"
        },
        {
          no: 2,
          title: "Instalasi Sistem MDM",
          description: "Konfigurasi pengendalian aplikasi, waktu penggunaan.",
          deliverables: ["MDM terkonfigurasi", "Policy penggunaan aktif", "Testing sistem kontrol"],
          duration: "2 minggu"
        },
        {
          no: 3,
          title: "Pembangunan Infrastruktur Pendukung",
          description: "Wi-Fi stabil di kelas. Pemasangan charging station & lemari penyimpanan.",
          deliverables: ["Jaringan WiFi upgrade", "Charging station terpasang", "Storage iPad aman"],
          duration: "3 minggu"
        },
        {
          no: 4,
          title: "Uji Coba Infrastruktur",
          description: "Tes kecepatan & jangkauan internet. Simulasi manajemen iPad di satu ruang kelas.",
          deliverables: ["Laporan testing jaringan", "Hasil simulasi kelas", "Perbaikan yang diperlukan"],
          duration: "1 minggu"
        }
      ]
    },
    {
      phase: "Tahap Pelatihan & Pendampingan",
      subtitle: "Membekali guru dengan kemampuan teknis & pedagogis dalam pembelajaran digital",
      icon: "fas fa-chalkboard-teacher",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-500",
      timeline: "Desember 2025 - Januari 2026",
      activities: [
        {
          no: 1,
          title: "Pelatihan Intensif Guru (Workshop)",
          description: "Pelatihan Penggunaan iPad & aplikasi pembelajaran. Pelatihan Sistem pelaporan presensi, nilai, rapor & portfolio santri (prestasi dan pelanggaran) digital.",
          deliverables: ["Sertifikat pelatihan guru", "Modul pelatihan", "Assessment kemampuan"],
          duration: "2 minggu"
        },
        {
          no: 2,
          title: "Pendampingan Berkala",
          description: "Simulasi mengelola kelas secara digital.",
          deliverables: ["Laporan pendampingan", "Feedback improvement", "Best practices"],
          duration: "4 minggu"
        },
        {
          no: 3,
          title: "Pembuatan Modul & Template Pelaporan",
          description: "Format pelaporan presensi, nilai, rapor & portfolio santri (prestasi dan pelanggaran) digital.",
          deliverables: ["Template pelaporan standar", "Panduan penggunaan", "Contoh implementasi"],
          duration: "2 minggu"
        }
      ]
    },
    {
      phase: "Tahap Orientasi",
      subtitle: "Membekali santri dengan literasi digital, etika penggunaan, & tanggung jawab",
      icon: "fas fa-graduation-cap",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      borderColor: "border-orange-500",
      timeline: "Februari 2026",
      activities: [
        {
          no: 1,
          title: "Pelatihan Siswa",
          description: "Mengenal iPad & aturan pemakaian. Simulasi penggunaan aplikasi belajar & pelaporan. Edukasi etika digital & keamanan.",
          deliverables: ["Modul orientasi siswa", "Sertifikat literasi digital", "Komitmen penggunaan"],
          duration: "1 minggu"
        },
        {
          no: 2,
          title: "Konfigurasi Akun MDM Siswa",
          description: "Setiap siswa mendapat akun yang dikontrol. Pemasangan aplikasi wajib.",
          deliverables: ["Akun MDM semua siswa", "Aplikasi terinstall", "Profile siswa aktif"],
          duration: "1 minggu"
        },
        {
          no: 3,
          title: "Distribusi iPad & Simulasi Harian",
          description: "Distribusi ke santri dengan dokumentasi. Simulasi kegiatan belajar & pelaporan 1 hari penuh.",
          deliverables: ["iPad terdistribusi", "Dokumentasi serah terima", "Laporan simulasi"],
          duration: "1 minggu"
        }
      ]
    },
    {
      phase: "Tahap Sosialisasi",
      subtitle: "Membangun dukungan & pemahaman dari orang tua terkait transformasi digital",
      icon: "fas fa-users",
      color: "from-pink-500 to-pink-600",
      bgColor: "bg-pink-50",
      borderColor: "border-pink-500",
      timeline: "Februari - Maret 2026",
      activities: [
        {
          no: 1,
          title: "Pembuatan Materi Sosialisasi",
          description: "Slide presentasi, booklet, atau video singkat.",
          deliverables: ["Materi presentasi", "Booklet program", "Video edukasi"],
          duration: "2 minggu"
        },
        {
          no: 2,
          title: "Pertemuan Wali Santri",
          description: "Penjelasan manfaat, fitur pengawasan, & peran wali. Penegasan bahwa program bersifat terbimbing & aman.",
          deliverables: ["Seminar wali santri", "Q&A session", "Feedback orang tua"],
          duration: "1 minggu"
        },
        {
          no: 3,
          title: "Surat Pernyataan & Komitmen",
          description: "Penandatanganan sebagai bentuk persetujuan wali.",
          deliverables: ["Surat persetujuan", "Komitmen bersama", "Database persetujuan"],
          duration: "1 minggu"
        }
      ]
    },
    {
      phase: "Tahap Piloting",
      subtitle: "Mengetes sistem, Uji coba secara terbatas untuk penyempurnaan sebelum implementasi penuh",
      icon: "fas fa-flask",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-500",
      timeline: "Maret - April 2026",
      activities: [
        {
          no: 1,
          title: "Menentukan Kelas Piloting",
          description: "2–3 kelas dengan guru siap pakai sistem penuh.",
          deliverables: ["Kelas pilot terpilih", "Guru pilot terlatih", "Kriteria seleksi"],
          duration: "1 minggu"
        },
        {
          no: 2,
          title: "Implementasi Simulasi 2 Minggu",
          description: "Belajar, presensi, pelaporan, semua berjalan digital.",
          deliverables: ["Laporan harian pilot", "Data penggunaan sistem", "Issue tracking"],
          duration: "2 minggu"
        },
        {
          no: 3,
          title: "Evaluasi & Perbaikan",
          description: "Pengumpulan feedback guru, siswa, wali kelas. Perbaikan SOP, regulasi, & sistem jika diperlukan.",
          deliverables: ["Laporan evaluasi pilot", "Rekomendasi perbaikan", "SOP yang direvisi"],
          duration: "2 minggu"
        }
      ]
    },
    {
      phase: "Tahap Implementasi",
      subtitle: "Menjalankan program ke seluruh sekolah dalam format trial & error",
      icon: "fas fa-rocket",
      color: "from-indigo-500 to-indigo-600",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-500",
      timeline: "April - Mei 2026",
      activities: [
        {
          no: 1,
          title: "Distribusi Final Perangkat",
          description: "Semua siswa & guru aktif menggunakan iPad.",
          deliverables: ["iPad untuk semua pengguna", "Setup akun lengkap", "Training refresher"],
          duration: "2 minggu"
        },
        {
          no: 2,
          title: "Monitoring & Evaluasi (intensif)",
          description: "Pemantauan harian/mingguan dari tim teknis & pengawas program.",
          deliverables: ["Dashboard monitoring", "Laporan harian", "Quick response team"],
          duration: "4 minggu"
        },
        {
          no: 3,
          title: "Evaluasi sistem & Perbaikan (Troubleshooting)",
          description: "Laporan awal ke pimpinan & yayasan.",
          deliverables: ["Laporan evaluasi", "Action plan perbaikan", "Escalation matrix"],
          duration: "2 minggu"
        },
        {
          no: 4,
          title: "Kesiapan Menuju Implementasi (Go Live)",
          description: "Penguatan regulasi.",
          deliverables: ["SOP final", "Regulasi tetap", "Readiness checklist"],
          duration: "1 minggu"
        }
      ]
    },
    {
      phase: "Tahap Go Live",
      subtitle: "Running trial & error (kontrol penuh)",
      icon: "fas fa-play-circle",
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-500",
      timeline: "Juni - Juli 2026",
      activities: [
        {
          no: 1,
          title: "Pelaksanaan sistem digitalisasi secara penuh",
          description: "Monitoring & Evaluasi (intensif).",
          deliverables: ["Sistem operasional penuh", "Monitoring real-time", "Support 24/7"],
          duration: "4 minggu"
        },
        {
          no: 2,
          title: "Laporan lanjutan ke pimpinan & yayasan",
          description: "Persiapan regulasi permanen & integrasi.",
          deliverables: ["Laporan komprehensif", "Regulasi permanen", "Sustainability plan"],
          duration: "4 minggu"
        }
      ]
    }
  ];

  const totalActivities = implementationPhases.reduce((total, phase) => total + phase.activities.length, 0);
  const totalDuration = "12 bulan";

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-6">
            <i className="fas fa-project-diagram text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Tahapan Implementasi Digitalisasi
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Roadmap lengkap 8 tahapan implementasi transformasi digital Al Wafi dari perencanaan hingga go live
          </p>
        </div>

        {/* Statistics Overview */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Overview Program</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">{implementationPhases.length}</div>
                <div className="text-blue-100">Tahapan</div>
                <div className="text-sm text-blue-200">Implementasi</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">{totalActivities}</div>
                <div className="text-blue-100">Aktivitas</div>
                <div className="text-sm text-blue-200">Total Kegiatan</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">{totalDuration}</div>
                <div className="text-blue-100">Durasi</div>
                <div className="text-sm text-blue-200">Agustus 2025 - Juli 2026</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-blue-100">Digital</div>
                <div className="text-sm text-blue-200">Transformasi</div>
              </div>
            </div>
          </div>
        </section>

        {/* Phase Navigation */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Pilih Tahapan</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {implementationPhases.map((phase, index) => (
              <button
                key={index}
                onClick={() => setActivePhase(index)}
                className={`p-4 rounded-xl text-left transition-all duration-300 transform hover:-translate-y-1 ${
                  activePhase === index
                    ? `bg-gradient-to-r ${phase.color} text-white shadow-lg scale-105`
                    : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg'
                }`}
              >
                <div className="flex items-center space-x-3 mb-2">
                  <i className={`${phase.icon} text-lg`}></i>
                  <span className="font-bold text-sm">{phase.phase}</span>
                </div>
                <div className={`text-xs ${activePhase === index ? 'text-white opacity-90' : 'text-gray-500'}`}>
                  {phase.activities.length} aktivitas
                </div>
              </button>
            ))}
          </div>
        </section>

        {/* Active Phase Detail */}
        <section className="mb-16">
          {implementationPhases.map((phase, index) => (
            activePhase === index && (
              <div key={index} className={`${phase.bgColor} rounded-2xl shadow-lg overflow-hidden`}>
                <div className={`h-2 bg-gradient-to-r ${phase.color}`}></div>
                <div className="p-8">
                  {/* Phase Header */}
                  <div className="flex items-center space-x-4 mb-6">
                    <div className={`w-16 h-16 bg-gradient-to-r ${phase.color} rounded-full flex items-center justify-center`}>
                      <i className={`${phase.icon} text-white text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-3xl font-bold text-gray-800">{phase.phase}</h3>
                      <p className="text-gray-600 text-lg">{phase.subtitle}</p>
                      <div className="flex items-center space-x-4 mt-2">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${phase.color} text-white`}>
                          <i className="fas fa-calendar-alt mr-2"></i>
                          {phase.timeline}
                        </span>
                        <span className="text-gray-500 text-sm">
                          {phase.activities.length} aktivitas utama
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Activities */}
                  <div className="space-y-6">
                    {phase.activities.map((activity, actIndex) => (
                      <div key={actIndex} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
                        <div className="flex items-start space-x-4">
                          <div className={`w-10 h-10 bg-gradient-to-r ${phase.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                            <span className="text-white font-bold">{activity.no}</span>
                          </div>
                          <div className="flex-1">
                            <h4 className="text-xl font-bold text-gray-800 mb-2">{activity.title}</h4>
                            <p className="text-gray-600 mb-4 leading-relaxed">{activity.description}</p>
                            
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                              {/* Deliverables */}
                              <div>
                                <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                                  <i className="fas fa-check-circle text-green-500 mr-2"></i>
                                  Deliverables
                                </h5>
                                <ul className="space-y-1">
                                  {activity.deliverables.map((deliverable, delIndex) => (
                                    <li key={delIndex} className="text-sm text-gray-600 flex items-start">
                                      <i className="fas fa-dot-circle text-green-400 mr-2 mt-1.5 text-xs"></i>
                                      {deliverable}
                                    </li>
                                  ))}
                                </ul>
                              </div>

                              {/* Duration */}
                              <div>
                                <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                                  <i className="fas fa-clock text-blue-500 mr-2"></i>
                                  Estimasi Durasi
                                </h5>
                                <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${phase.color} text-white`}>
                                  {activity.duration}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          ))}
        </section>

        {/* Success Metrics */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Indikator Keberhasilan</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center p-6 bg-blue-50 rounded-xl">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-users text-white text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-blue-700 mb-2">Tim Terbentuk</h3>
                <p className="text-blue-600 text-sm">Struktur organisasi lengkap dengan job description yang jelas</p>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-cogs text-white text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-green-700 mb-2">Sistem Siap</h3>
                <p className="text-green-600 text-sm">Infrastruktur dan perangkat lunak berfungsi optimal</p>
              </div>
              <div className="text-center p-6 bg-purple-50 rounded-xl">
                <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-graduation-cap text-white text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-purple-700 mb-2">SDM Terlatih</h3>
                <p className="text-purple-600 text-sm">Guru dan staff memiliki kompetensi digital yang memadai</p>
              </div>
              <div className="text-center p-6 bg-orange-50 rounded-xl">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-chart-line text-white text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-orange-700 mb-2">Operasional</h3>
                <p className="text-orange-600 text-sm">Sistem berjalan stabil dengan monitoring berkelanjutan</p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-8 text-white">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
              <i className="fas fa-project-diagram text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4">Siap Memulai Transformasi Digital?</h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Ikuti 8 tahapan implementasi ini untuk memastikan transformasi digital Al Wafi berjalan sukses dan berkelanjutan
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-download mr-2"></i>
                Download Roadmap
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-phone mr-2"></i>
                Konsultasi Tim
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ImplementationPhases;
